module.exports = __webpack_public_path__ + "static/media/rectangle-mobile.528c356f.png";